//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'resultUpgrade',
  data: function data() {
    return {
      enterprise_audit_desc: '',
      enterprise_name: '',
      countdown: '',
      status: null,
      setIntervalTime: null,
      currCountdown: ''
    };
  },
  props: {
    setData: {}
  },
  methods: {
    formatBit: function formatBit(val) {
      val = +val;
      return val > 9 ? val : '0' + val;
    },
    // 秒转时分秒，求模很重要，数字的下舍入
    formatSeconds: function formatSeconds(time) {
      var min = Math.floor(time % 3600);
      return this.countdown = this.formatBit(Math.floor(time / 3600)) + ':' + this.formatBit(Math.floor(min / 60)) + ':' + this.formatBit(time % 60);
    },
    // 定时器
    minReturn: function minReturn(time) {
      var _this = this;

      var vm = this;
      this.setIntervalTime = setInterval(function () {
        time--;
        vm.formatSeconds(time);

        if (time <= 0) {
          clearInterval(_this.setIntervalTime);
        }
      }, 1000);
    },
    init: function init() {
      clearInterval(this.setIntervalTime);
      this.$set(this, 'enterprise_audit_desc', this.setData.enterprise_audit_desc);
      this.$set(this, 'enterprise_name', this.setData.enterprise_name);
      this.$set(this, 'currCountdown', this.setData.countdown);
      this.$set(this, 'status', this.setData.status);

      if (this.status === 1) {
        if (this.currCountdown == '0') {
          this.countdown = '00:00:00';
        } else {
          this.minReturn(this.currCountdown);
        }
      }
    },
    resetAuthener: function resetAuthener() {
      this.$emit('reSubmit');
    }
  }
};